export const LICENSE_TYPE_STANDARD_VALUE = 'STANDARD';
export const LICENSE_TYPE_FLEXIBLE_VALUE = 'FLEXIBLE';

export const licenseType = {
  key: 'licenseType',
  label: 'License type',
  options: [
    { key: 'standard', value: LICENSE_TYPE_STANDARD_VALUE, text: 'Standard' },
    { key: 'flexible', value: LICENSE_TYPE_FLEXIBLE_VALUE, text: 'Flexible' },
  ],
};

export const ROLE_TEAM_MEMBER_VALUE = 'TEAM_MEMBER';

export const role = {
  key: 'role',
  label: 'Role',
  placeholder: 'Select role',
};

export const customRole = {
  key: 'customRole',
  label: 'Role',
  placeholder: 'Search by Legacy or Custom Role name',
};

export const teamLeader = {
  key: 'teamLeaderId',
  currentValueKey: 'teamLeader',
  label: 'Team Leader',
  placeholder: 'Search by name',
};

export const emailAddress = {
  key: 'emailAddress',
  label: 'Email Address',
  placeholder: 'Enter email address',
};

export const countryCode = {
  key: 'countryCode',
  label: 'Country',
};

export const profileImage = {
  key: 'profileImage',
  label: 'Profile Image',
};

export const firstName = {
  key: 'firstName',
  label: 'First Name',
  placeholder: 'Enter first name',
};

export const lastName = {
  key: 'lastName',
  label: 'Last Name',
  placeholder: 'Enter last name',
};

export const homeTown = {
  key: 'homeTown',
  label: 'Home Town',
  placeholder: 'Enter home town',
};

export const stateOrCountry = {
  key: 'stateOrCountry',
  label: 'State or country',
  placeholder: 'Enter state or country',
};

export const profileBio = {
  key: 'profileBio',
  label: 'Profile (140 characters max)',
  placeholder: 'Enter bio information',
};

export const employeeId = {
  key: 'employeeId',
  label: 'Employee ID (if applicable)',
  placeholder: 'Enter ID',
};

export const customEmployeeId = {
  key: 'customEmployeeId',
  label: 'Employee ID (if applicable)',
  placeholder: 'Enter ID',
};

export const startDate = {
  key: 'startDate',
  label: 'Start Date',
  placeholder: 'Enter start date',
};

export const EMPLOYMENT_STATUS_FULL_TIME_VALUE = 'FULL_TIME';

export const employmentStatus = {
  key: 'employmentStatus',
  label: 'Employment status',
  options: [
    {
      key: 'fulltime',
      value: EMPLOYMENT_STATUS_FULL_TIME_VALUE,
      text: 'Full-time',
    },
    { key: 'parttime', value: 'PART_TIME', text: 'Part-time' },
    { key: 'temp', value: 'TEMP', text: 'Temp' },
  ],
};

export const channels = {
  key: 'channel',
  label: 'On which channel(s) does this team member work?',
  options: [
    { key: 'phone', value: 'PHONE', text: 'Phone interactions' },
    { key: 'chat', value: 'CHAT', text: 'Chat interactions' },
    { key: 'email', value: 'EMAIL', text: 'Email interactions' },
  ],
};

export const temporaryPassword = {
  key: 'temporaryPassword',
  label: 'Temporary password',
  placeholder: 'Enter temporary password here',
};

export const reportingGroups = {
  key: 'reportingGroupIds',
  currentGroupsKey: 'reportingGroups',
  label: 'Group Membership',
  placeholder: 'Select groups',
};

export const deactivated = {
  key: 'deactivated',
  label: 'Deactivated',
};

export const manageTeam = {
  key: 'canManageTeams',
  label: 'Can Manage Teams',
  options: [
    { key: 'yes', value: true, text: 'Yes' },
    { key: 'no', value: false, text: 'No' },
  ],
  helpText:
    'When Yes is selected, this user will be considered a possible Team Leader. You will see this user available to select as a Team Leader for users being created or updated. When a user Can Manage Teams, their Role and associated permissions & data visibility will not be affected.',
};

export const sendResetPasswordEmail = {
  label: 'Send reset password email',
};

export const BASE_REQUIRED_FIELDS = ['firstName', 'lastName'];
export const FEEDBACK_REQUIRED_FIELDS = ['role', 'teamLeader', 'channel'];
export const PROFILE_IMAGE_FIELD = 'profileImage';
export const BYOS_OPTIONAL_FIELDS = ['stateOrCountry', 'profileBio'];
export const employeeStatuses = {
  ACTIVE: 'Active',
  CONFIRMED: 'Confirmed',
  CREATED: 'Created',
  DEACTIVATED: 'Deactivated',
  PENDING_REVIEW: 'Pending Review',
  UNAPPROVED: 'Unapproved',
};

export const employeeRoles = {
  COMPANY_ADMIN: 'Company Admin',
  TEAM_LEADER: 'Team leader',
  TEAM_MEMBER: 'Team member',
};

export const ROLE_TEMPLATE_TEAM_MEMBER_VALUE = 'legacy_agent';
export const LEGACY_ROLE_TEAM_MEMBER_VALUE = 'Team Member [Default]';
export const NO_USERS = 'No users have been found.';
export const SEARCHING = 'Loading...';
export const DEACTIVATE_USER_LABEL = 'Deactivate User';
export const MANAGE_GROUPS_LABEL = 'Manage Groups';

export const DEACTIVATE_USER_ID = 'deactivate-user';
export const MANAGE_GROUPS_ID = 'manage-groups';
export const EDIT_USER_ID = 'edit-user';

export const CREATE_USER_ID = 'create-user';
export const CREATE_USER_LABEL = 'Create User';
export const INVITE_USER_ID = 'invite-user';
export const INVITE_USER_LABEL = 'Invite User';
export const BULK_CREATE_USERS_ID = 'bulk-create-users';
export const BULK_CREATE_USERS_LABEL = 'Bulk Create Users';
